var map = {
	"./logo_en_US.png": "x97H",
	"./logo_zh_CN.png": "keEg",
	"./logo_zh_HANT.png": "V0hQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8xO/";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/logo_.*\.png$
// module id = 8xO/
// module chunks = 1